// extracted by mini-css-extract-plugin
export default {"btn_wrapper":"favorite_btn_wrapper__jZr+v","btn":"favorite_btn__ZIskS"};